import { Component, OnInit, OnDestroy } from '@angular/core';;
import { FormGroup, FormControl } from '@angular/forms';
import { InventoryService } from '@app/services/inventory/inventory.service'
import { first, skipWhile, Subscription } from 'rxjs';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { selectCountsState } from '../store/selectors/counts.selectors';
import * as CountsActions from '../store/actions/counts.actions';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { MatDialog } from '@angular/material/dialog';
import { SendMailModalComponent } from '@app/shared/components/send-mail-modal/send-mail-modal.component';
import { LimitAccessService } from '@app/core/services/limit-access.service';

@Component({
  selector: 'app-poworksheet',
  templateUrl: './poworksheet.component.html',
  styleUrls: ['./poworksheet.component.scss']
})
export class PoworksheetComponent implements OnInit, OnDestroy {
  public settings$;
  public isFinalizedScreen = this._inventory.isFinalizeScreen();
  public inventory: any = {};
  public inventoryItems;
  public endTimeStamp: string;
  public inventorySubscription: Subscription;
  public isLoading: boolean = true;
  public dataLength: boolean = true;
  public prdMinQtyForm: FormGroup;
  public prdMinQtyValue = "0";
  public subs = new SubSink;
  private id;
  public mls1Option: boolean = false;
  public mls2Option: boolean = false;
  public hasAsteriskProducts = false;

  constructor(
    private _inventory: InventoryService,
    private store$: Store,
    private _matDialog: MatDialog,
    private limitAccessService: LimitAccessService
  ) {
    this.subs.add(this.store$.select(selectCountsState).subscribe(res => this.id = res.currentId));
    this.store$.dispatch(CountsActions.loadPO({ invID: this.id, prdMinQty: 1 }));
  }

  ngOnInit(): void {
    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        let resultMls1 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls1');
        let resultMls2 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls2');
        this.mls1Option = resultMls1;
        this.mls2Option = resultMls2;
      }
    });

    this.subs.add(this.store$.select(selectCountsState).pipe(skipWhile(({ currentInventory }) => currentInventory == null)).subscribe(({ currentInventory, isLoading }) => {
      
      currentInventory.invItems.forEach(category => {
        const uniqueItemsMap = new Map();
        
        category?.data?.forEach(item => {
          if (uniqueItemsMap.has(item.prdCode)) {
            const existingItem = uniqueItemsMap.get(item.prdCode);
            existingItem.invitmCount += item.invitmCount;
            existingItem.onHand += item.onHand;
            existingItem.isCombined = true;  
            this.hasAsteriskProducts = true;
          } else {
            const newItem = { ...item, isCombined: false }; 
            uniqueItemsMap.set(item.prdCode, newItem);
          }
        });
        
        category.data = Array.from(uniqueItemsMap.values());
      });
      
      this.inventory = currentInventory.inv;
      this.inventoryItems = currentInventory.invItems;
      this.endTimeStamp = currentInventory.endTimeStamp;
      this.isLoading = false;

      this.dataLength = this.inventoryItems.some(item => item.data.length > 0);
    }));

    this.subs.add(this.store$.select(selectSettingsState).subscribe((settings) => {
      this.settings$ = settings
      this.prdMinQtyForm = new FormGroup({ prdMinQty: new FormControl(0) });
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  generatePDF(): void {
    this._inventory.generatePOPDF(this.prdMinQtyValue, this.isFinalizedScreen ? 1 : 0);
  }

  public onNavigate(prdID) {
    // this._dialogRef.close();
    // this._router.navigate([`/products/${prdID}`]);
    // this._inventory.onSetIsInvOpen(true);
  }

  parseInt(num) {
    return Number(num);
  }

  orderQty(item): string {
    if (this.prdMinQtyValue == "1") {
      if (item.countType.pcmMinQty1 > 0) {
        if (item.orderQty < 0.00) {
          return 'Over';
        } else {
          return item.orderQty?.toFixed(2);
        }
      } else {
        return '/';
      }
    } else {
      if (item.prdMinQty2 > 0) {
        if (item.orderQty < 0.00) {
          return 'Over';
        } else {
          return item.orderQty.toFixed(2);
        }
      } else {
        return '/';
      }
    }

  }

  setMinQty(event) {
    this.prdMinQtyValue = event.value;
  }

  onRound(value) {
    return Math.max(0, value);
  }

  sendReport() {
    const dialog = this._matDialog.open(SendMailModalComponent, {
      minWidth: '30vw',
      maxWidth: '700px',
    });

    dialog.afterClosed().pipe(first()).subscribe(res => {
       if(res!=null && res.email!=null && res.email!=''){
        const data = {
          email: res.email,
          id: this.inventory.invID,
          finalized: this._inventory.isFinalizeScreen() ? 1 : 0,
          min_qty_option: this.prdMinQtyValue,
          type: 'byCategory'
        }

          this._inventory.onSendReportPDF(data);
        }
    });
  }

}
